<template>
    <div>
        <b-card text-variant="white" class="text-center" style="width: 100%;">
            <div class="card-body text-center">
                <div class="row d-flex w-100 justify-content-center">
                    <div class="col-1" v-on:click="changeurl('register-judul')"  style="cursor: pointer;">
                        <b-avatar variant="primary" text="1" style="float: right;left: 23%;z-index: 1;"></b-avatar>
                        <p class="text-dark" style="float: right;left: 55%;position: relative;">Pengajuan Judul</p>
                    </div>
                    <div class="col-2">
                        <span
                            style="background-color: #3751E4;width: 109%;height: 3px;display: inherit;position: absolute;top: 26%;float: right;left: 2%;"></span>
                    </div>
                    <div class="col-1" v-on:click="changeUrlSempro" style="cursor: pointer;">
                        <b-avatar :variant="active === 'sempro' || active === 'sidang' || active === 'wisuda' ? 'primary' : 'warning'" text="2" class="text-white" @click="changeurl('regiter-sidang')"></b-avatar>
                        <p class="text-dark">Ujian Proposal</p>
                    </div>
                    <div class="col-2">
                        <span
                            :style="active === 'sidang' || active === 'wisuda' ? styleObject : 'background-color: rgb(255, 184, 0);width: 123%;height: 3px;display: inherit;position: absolute;top: 26%;float: right;left: -10%;'"></span>
                    </div>
                    <div class="col-1" v-on:click="changeUrlSidang" style="cursor: pointer;">
                        <b-avatar :variant="active === 'sidang' || active === 'wisuda' ? 'primary' : 'warning'" text="3" class="text-white" @click="changeurl('regiter-sidang')"></b-avatar>
                        <p class="text-dark">Ujian Tugas Akhir</p>
                    </div>
                    <!-- <div class="col-2">
                        <span
                            :style="active === 'sidang' || active === 'wisuda' ? styleObject : 'background-color: rgb(255, 184, 0);width: 123%;height: 3px;display: inherit;position: absolute;top: 26%;float: right;left: -10%;'"></span>
                    </div>
                    <div class="col-1" v-on:click="changeurl('register-wisuda')"  style="cursor: pointer;">
                        <b-avatar :variant="active === 'wisuda' ? 'primary' : 'warning'" text="4" class="text-white" @click="changeurl('regiter-wisuda')"></b-avatar>
                        <p class="text-dark">Pendaftaran Wisuda</p>
                    </div> -->
                </div>
            </div>
        </b-card>
    </div>
</template>

<script>
import axios from "axios";

export default {
    name: 'CardSempro',
    data(){
        return{
            styleObject: {
                backgroundColor: '#3751E4',
                width: '123%',
                height: '3px',
                display: 'inherit',
                position: 'absolute',
                top: '26%',
                float: 'right',
                left: '-10%',
            },
            isCekProposal: null,
            isCekStatusUjian: null,
            isNextProposal: null,
            isNextTugasAkhir: null,
            dataLogin: JSON.parse(localStorage.getItem('dataLogin')),
            redirectDone: false, 
        }
    },
    props: {
        active: {
            type: String,
            default: () => 'judul'
        }
    },
    async mounted() {
        await this.getCekStatusProposal();
        await this.getValidasiUjianProposal();
        await this.getValidasiUjianTugasAkhir();

        const redirectDone = localStorage.getItem('redirectDone') !== 'true';

        if (redirectDone && this.isCekProposal === 1 && this.isCekStatusUjian === null) {
            if (this.isNextProposal?.dosen_pembimbing !== null && this.isNextProposal?.dosen_pembimbing === 1) {
                this.$router.push({ path: 'register-sempro' }).catch(() => {});
                localStorage.setItem('redirectDone', true);
            }
        } else if (redirectDone && this.isCekProposal === 1 && this.isCekStatusUjian === 2) {
            if (this.isNextTugasAkhir?.data_nilai !== null && this.isNextTugasAkhir?.file_skripsi >= 1) {
                this.$router.push({ path: 'register-sidang' }).catch(() => {});
                localStorage.setItem('redirectDone', true);
            }
        }
    },

    methods: {
        changeurl(params) {
            this.$router.push({ path: params }).catch(() => { });
        },
        async getCekStatusProposal() {
            try {
                const res = await axios.get('/pengajuan-skripsi/siswa/cek-status-proposal');

                if (res.data.meta.code === 200) {
                    const data = res.data.data;

                    if (data !== null) {
                        this.isCekProposal = data?.status ?? null;
                        this.isCekStatusUjian = data?.status_ujian ?? null;
                        localStorage.setItem('isCekProposal', data?.status ?? 0);
                        localStorage.setItem('isCekStatusUjian', data?.status_ujian ?? null);
                    } else {
                        this.isCekProposal = null;
                        this.isCekStatusUjian = null;
                        localStorage.setItem('isCekProposal', data?.status ?? null);
                        localStorage.setItem('isCekStatusUjian', data?.status_ujian ?? null);
                    }
                }
            } catch (error) {
                throw error;
            }
        },

        async getValidasiUjianProposal() {
            try {
                const res = await axios.get(`/proposal/proposal-validasi-judul/${this.dataLogin.key_siswa}`);

                if (res.data.meta.code === 200) {
                    const data = res.data.data;

                    if (data !== null) {
                        this.isNextProposal = data;
                        localStorage.setItem("isProposal", JSON.stringify(data));
                    } else {
                        this.isNextProposal = null;
                    }
                }else{
                    this.isNextProposal = null;
                }
            } catch (error) {
                // Handle 500 Internal Server Error here
                this.isNextProposal = null;
                throw error;
            }
        },

        async getValidasiUjianTugasAkhir() {
            try {
                const res = await axios.get(`/proposal/validasi-ujian-proposal/${this.dataLogin.key_siswa}`);

                if (res.data.meta.code === 200) {
                    const data = res.data.data;

                    if (data !== null) {
                        this.isNextTugasAkhir = data;
                        localStorage.setItem("isTugasAkhir", JSON.stringify(data));
                    } else {
                        this.isNextTugasAkhir = null;
                    }
                }else{
                    this.isNextTugasAkhir = null;
                }
            } catch (error) {
                // Handle 500 Internal Server Error here
                this.isNextTugasAkhir = null;
                throw error;
            }
        },
        async changeUrlSempro() {
            const swalOptions = {
                title: 'Perhatian',
                text: 'Anda Belum Terdaftar Ujian Proposal',
                icon: 'warning',
                confirmButtonText: 'OK',
                confirmButtonColor: '#3751E4',
            };

            if (this.isCekProposal === 1) {
                if (this.isCekStatusUjian === null || this.isCekStatusUjian === 2) {
                    if(this.isNextProposal?.dosen_pembimbing !== null && this.isNextProposal?.status_judul === 1){
                        this.$router.push({ path: 'register-sempro' }).catch(() => {});
                    }else{
                        this.$swal({
                            title: 'Perhatian',
                            text: 'Judul Tugas Akhir anda belum disetujui',
                            icon: 'warning',
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#3751E4',
                        });
                    }
                } else {
                    this.$swal(swalOptions);
                }
            } else {
                this.$swal(swalOptions);
                this.$router.push({ path: 'register-judul' }).catch(() => {});
            }
        },

        async changeUrlSidang() {
            const swalOptions = {
                title: 'Perhatian',
                text: 'Anda Belum Terdaftar Ujian Tugas Akhir',
                icon: 'warning',
                confirmButtonText: 'OK',
                confirmButtonColor: '#3751E4',
            };

            if (this.isCekProposal === 1) {
                if (this.isCekStatusUjian === 2) {
                    if(this.isNextTugasAkhir?.data_nilai !== null && this.isNextTugasAkhir?.file_skripsi >= 1){
                        this.$router.push({ path: 'register-sidang' }).catch(() => {});
                    }else{
                        this.$swal({
                            title: 'Perhatian',
                            text: 'Anda belum bisa lanjut ke tahap berikutnya mohon dilengkapi persyaratannya',
                            icon: 'warning',
                            confirmButtonText: 'OK',
                            confirmButtonColor: '#3751E4',
                        });
                    }
                } else {
                    this.$swal(swalOptions);
                }
            } else if(this.isCekStatusUjian === null && this.isCekProposal === 1) {
                this.$swal(swalOptions);
                this.$router.push({ path: 'register-sempro' }).catch(() => {});
            }else{
                this.$swal(swalOptions);
                this.$router.push({ path: 'register-judul' }).catch(() => {});
            }
        }
    },
}
</script>